import { forwardRef } from 'react';
import styled from 'styled-components';
import { Button, ButtonProps } from '../Button';

interface LinkButtonProps
    extends Omit<ButtonProps, 'type'>,
        Pick<React.HTMLProps<HTMLLinkElement>, 'href' | 'download' | 'target' | 'rel'> {}

const LinkElement = styled.a`
    text-decoration: none;
`;

const LinkButton = forwardRef<HTMLButtonElement, LinkButtonProps>((props, ref) => (
    <Button asTag={LinkElement} {...props} type="button" ref={ref} />
));

export default LinkButton;
